import * as yup from 'yup';

/** Campos de agendamento (switch + data inicial e final) dos formulários de grupo. */
export default function montarSchemaAgendamento(obrigatorio = false) {
  return {
    schedule: yup.boolean(),
    schedule_start: yup
      .mixed()
      .when('schedule', {
        is: (agendado: boolean) => agendado || obrigatorio,
        then: yup.date().required('Data de início é obrigatória'),
      })
      .optional(),
    schedule_end: yup
      .mixed()
      .when(['schedule', 'schedule_start'], (schedule, schedule_start) => {
        if (!schedule && !obrigatorio) return yup.date();
        if (schedule_start) {
          return yup
            .date()
            .min(schedule_start, 'Data final deve ser superior a data inicial')
            .required('Data Final é obrigatória');
        }
        return yup.date().required('Data Final é obrigatória');
      }),
  };
}
